<script lang="ts">
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import InfoBannerTitle from "./InfoBannerTitle.svelte";
	import Link from "./Link.svelte";
	import { flyInOnScroll } from "../utils/flyInOnScroll";
	import { nbspifyHtml } from "../../../core/utils/nbspifyHtml.js";
	import type { SourceSetQuery } from "../utils/SourceSetQuery.js";

	export let id: string;
	export let image: string | undefined = undefined;
	export let imageSourcesets: Partial<Record<SourceSetQuery, string>> = {};
	export let wrapperClasses: string | undefined = undefined;
	export let contentClasses: string | undefined = undefined;
	export let contentColor: "white" | "transparent" = "white";
	export let title: string;
	export let linkText: string | undefined = undefined;
	export let textBlockPosition: "left" | "right" = "left";
	export let shrink: "toBottom" | "toTop" | "dont" = "dont";
	/* eslint-disable svelte/no-at-html-tags */
</script>

<div {id} class="relative z-10 flex min-h-screen p-3 sm:p-5 md:px-[4.375rem] md:py-[3.75rem] {wrapperClasses}">
	{#if image}
		<StaticPicture
			{image}
			alt={title}
			width={1920}
			height={1080}
			imgClass="absolute inset-0 w-full h-full object-cover"
			class="absolute inset-0 -z-10"
			sourcesets={imageSourcesets}
		/>
	{/if}

	<div
		class="container flex h-[45.5rem] flex-col items-center justify-between gap-10 min-[475px]:h-[37.5rem] lg:mt-0 lg:h-full lg:flex-row lg:items-stretch {shrink ===
		'toBottom'
			? 'self-end'
			: ''}"
	>
		<div
			use:flyInOnScroll
			class="relative flex w-full max-w-[49.125rem] flex-col justify-between p-4 px-7 py-10 pt-8 sm:p-5 md:px-[3.625rem] md:pb-16 md:pt-[4.625rem] lg:max-w-[min(50%,49.125rem)] {textBlockPosition ===
			'left'
				? 'justify-self-start'
				: 'justify-self-end lg:ml-auto'} {shrink === 'toBottom'
				? 'h-fit self-end lg:min-h-[60%]'
				: shrink === 'toTop'
					? 'self-start'
					: 'h-full'} {contentClasses}"
		>
			<InfoBannerTitle {title} />
			<slot name="content" />
			<div
				class="absolute inset-0 -z-10 {contentColor === 'white' ? 'bg-white/90 backdrop-blur' : 'bg-transparent'}"
			></div>
		</div>
		{#if linkText}
			<Link containerClass="flex items-end" animated asButton href="#" class="mx-auto lg:mr-0">
				{@html nbspifyHtml(linkText)}
			</Link>
		{/if}
	</div>
</div>
